import React, {Component} from "react";
import Provider from "pubsub-js";
import {
  SELECTION_CREATED,
  BEFORE,
  SELECTION_CLEARED,
  OBJECT_MOVING,
  OBJECT_SCALING,
  OBJECT_ROTATING,
  OBJECT_MODIFIED,
  TOUCH_MOVE
} from "../constants/event-types";
import {ContextMenuTrigger} from "react-contextmenu";

export default (OriginalComponent) =>
  class DecoratedComponent extends Component {
    state = {
      disableObjectContextMenu: true
    };
    componentDidMount() {
      Provider.subscribe(OBJECT_MOVING, this.changeStateContextMenu(true));
      Provider.subscribe(OBJECT_SCALING, this.changeStateContextMenu(true));
      Provider.subscribe(OBJECT_ROTATING, this.changeStateContextMenu(true));
      Provider.subscribe(OBJECT_MODIFIED, this.changeStateContextMenu(false));
      Provider.subscribe(SELECTION_CREATED, this.changeStateContextMenu(false));
      Provider.subscribe(SELECTION_CLEARED, this.changeStateContextMenu(true));
      Provider.subscribe(
        SELECTION_CREATED + BEFORE,
        this.changeStateContextMenu(false)
      );
      Provider.subscribe(
        SELECTION_CLEARED + BEFORE,
        this.changeStateContextMenu(true)
      );
      Provider.subscribe(TOUCH_MOVE, this.changeStateContextMenu(true));
    }
    componentWillUnmount() {
      Provider.unsubscribe(SELECTION_CREATED + BEFORE);
      Provider.unsubscribe(SELECTION_CLEARED + BEFORE);
      Provider.unsubscribe(OBJECT_SCALING);
      Provider.unsubscribe(OBJECT_MOVING);
      Provider.unsubscribe(OBJECT_ROTATING);
      Provider.unsubscribe(OBJECT_MODIFIED);
      Provider.unsubscribe(SELECTION_CREATED);
      Provider.unsubscribe(SELECTION_CLEARED);
      Provider.unsubscribe(TOUCH_MOVE);
    }
    changeStateContextMenu = (val) => () => {
      if (val !== this.state.disableObjectContextMenu) {
        this.setState({
          disableObjectContextMenu: val
        });
      }
    };
    render() {
      const {disableObjectContextMenu} = this.state;
      return (
        <ContextMenuTrigger
          disable={!disableObjectContextMenu}
          id="context-menu"
          holdToDisplay={-1}
        >
          <ContextMenuTrigger
            disable={disableObjectContextMenu}
            id="object-context-menu"
            holdToDisplay={-1}
          >
            <OriginalComponent {...this.props} {...this.state} />
          </ContextMenuTrigger>
        </ContextMenuTrigger>
      );
    }
  };
